import FAQ from "../sections/FAQ";

export default function FAQPage() {
  return (
    <div data-testid="faq-page">
      <FAQ />
    </div>
  );
}
